import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

const ModalStatusCreate = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.createStatus');
  const onClose = () => {
    closeSingleModal('createStatus');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Novo status"
      height={'auto'}
      width={'60vw'}
    >
      <Form.Validity.Status.Create />
    </Modal>
  );
};

export default ModalStatusCreate;
